﻿export const COMMON_BARCODE_IDS = [
  "UpcA",
  "UpcE",
  "Ean13",
  "Ean8",
  "Code128",
  "GS1128",
  "Code39",
  "Interleaved2of5",
  "Itf14",
  "QRCode",
  "DataMatrix",
  "Pdf417",
] as const;

export type CommonBarcodeId = (typeof COMMON_BARCODE_IDS)[number];

/** Names as they appear in the DinLabel barcode type selector. */
export const ALL_SUPPORTED_BARCODE_TYPES = [
  "Codabar",
  "Code11",
  "Code16k",
  "Code39",
  "Code93",
  "Code128",
  "DataMatrix",
  "Ean8",
  "Ean13",
  "Industrial2of5",
  "Interleaved2of5",
  "Isbn",
  "Msi",
  "Pdf417",
  "Planet",
  "Postnet",
  "UccEan128",
  "UpcA",
  "UpcE",
  "UspsOneCode4CB",
  "RoyalMail",
  "AustraliaPost",
  "RoyalTpgPostKix",
  "Sscc18",
  "Pzn",
  "DeutschePostLeitcode",
  "DeutschePostIdentcode",
  "UspsTrayLabel",
  "UspsSackLabel",
  "EanVelocity",
  "SingaporePost",
  "Jan8",
  "Jan13",
  "SwissPostParcel",
  "Opc",
  "Ean99",
  "Itf14",
  "Scc14",
  "Issn",
  "Ismn",
  "NumlyNumber",
  "QRCode",
  "UspsFim",
  "UspsHorizontalBars",
  "Telepen",
  "Pharmacode",
  "Semacode",
  "Code32",
  "UspsPicUccEan128",
  "FedExGround96",
  "AztecCode",
  "CompactPdf417",
  "MacroPdf417",
  "MicroPdf417",
  "VicsBol",
  "VicsScacPro",
  "ItalianPost25",
  "Isbt128",
  "HibcLic39",
  "HibcLic128",
  "HibcPas39",
  "HibcPas128",
  "UspsIntelligentMail",
  "EanUpcAddOn2",
  "EanUpcAddOn5",
  "UspsPicCode128",
  "GS1DataBarOmnidirectional",
  "GS1DataBar14",
  "Rss14",
  "GS1DataBarTruncated",
  "GS1DataBar14Truncated",
  "Rss14Truncated",
  "GS1DataBarStacked",
  "GS1DataBar14Stacked",
  "Rss14Stacked",
  "GS1DataBarStackedOmnidirectional",
  "GS1DataBar14StackedOmnidirectional",
  "Rss14StackedOmnidirectional",
  "GS1DataBarLimited",
  "RssLimited",
  "GS1DataBarExpanded",
  "RssExpanded",
  "GS1DataBarExpandedStacked",
  "RssExpandedStacked",
  "GS1128",
  "MaxiCode",
  "MicroQRCode",
  "Matrix2of5",
  "DanishPostal39",
  "FrenchPostal39AR",
  "IATA2of5",
  "AustraliaPostDomesticEParcelBarcode",
  "UspsIntelligentMailContainerBarcode",
  "KodakPatchCode",
  "GS1DataMatrix",
  "Ean13CCA",
  "Ean13CCB",
  "Ean8CCA",
  "Ean8CCB",
  "UpcACCA",
  "UpcACCB",
  "UpcECCA",
  "UpcECCB",
  "UccEan128CCA",
  "UccEan128CCB",
  "UccEan128CCC",
  "GS1128CCA",
  "GS1128CCB",
  "GS1128CCC",
  "GS1DataBarOmnidirectionalCCA",
  "GS1DataBar14CCA",
  "Rss14CCA",
  "GS1DataBarOmnidirectionalCCB",
  "GS1DataBar14CCB",
  "Rss14CCB",
  "GS1DataBarTruncatedCCA",
  "GS1DataBar14TruncatedCCA",
  "Rss14TruncatedCCA",
  "GS1DataBarTruncatedCCB",
  "GS1DataBar14TruncatedCCB",
  "Rss14TruncatedCCB",
  "GS1DataBarLimitedCCA",
  "RssLimitedCCA",
  "GS1DataBarLimitedCCB",
  "RssLimitedCCB",
  "GS1DataBarStackedCCA",
  "GS1DataBar14StackedCCA",
  "Rss14StackedCCA",
  "GS1DataBarStackedCCB",
  "GS1DataBar14StackedCCB",
  "Rss14StackedCCB",
  "GS1DataBarStackedOmnidirectionalCCA",
  "GS1DataBar14StackedOmnidirectionalCCA",
  "Rss14StackedOmnidirectionalCCA",
  "GS1DataBarStackedOmnidirectionalCCB",
  "GS1DataBar14StackedOmnidirectionalCCB",
  "Rss14StackedOmnidirectionalCCB",
  "GS1DataBarExpandedCCA",
  "RssExpandedCCA",
  "GS1DataBarExpandedCCB",
  "RssExpandedCCB",
  "GS1DataBarExpandedStackedCCA",
  "RssExpandedStackedCCA",
  "GS1DataBarExpandedStackedCCB",
  "RssExpandedStackedCCB",
  "MICRE13B",
  "Ean14",
  "Dun14Itf",
  "Dun14Ean",
  "GS1QRCode",
  "Ppn",
  "IFAsecurPharm",
  "DhlAwb",
  "HibcLicDataMatrix",
  "HibcLicQRCode",
  "HibcLicAztecCode",
  "HibcPasDataMatrix",
  "HibcPasQRCode",
  "HibcPasAztecCode",
  "Isbt128DataMatrix",
  "DeutschePostResponsePlusPostMatrix",
  "DeutschePostBzl",
  "UspsIntelligentMailPackageBarcode",
  "HanXinCode",
] as const;

export function isCommonBarcodeId(name: string): name is CommonBarcodeId {
  return (COMMON_BARCODE_IDS as readonly string[]).includes(name);
}
